import { type Camera, Matrix4 } from 'three';

/**
 * "이번 프레임에 오버레이를 다시 그려야 하는가" 판정. Client·Area·시뮬레이션의 프레임 드라이버가
 * 같은 규칙을 공유합니다. 다시 그리는 조건은 최초 프레임, dirty 세대 변경, 카메라 월드 행렬 변경,
 * 카메라 투영 행렬 변경입니다. 그 외의 always 프레임은 2D bitmap 재제출을 생략합니다.
 */
export const createOverlayPaintGate = (getGeneration: () => number) => {
  let generation = 0;
  let hasPainted = false;
  const matrixWorld = new Matrix4();
  const projectionMatrix = new Matrix4();

  return {
    /**
     * 필요할 때만 `paint` 를 호출하고 호출 여부를 돌려줍니다. 세대는 도장 전에 읽어 두므로
     * 도장 중에 다시 dirty 가 되면 다음 프레임에 한 번 더 그립니다.
     */
    paintIfNeeded: (camera: Camera, paint: () => void): boolean => {
      const current = getGeneration();
      const shouldPaint =
        !hasPainted ||
        generation !== current ||
        !matrixWorld.equals(camera.matrixWorld) ||
        !projectionMatrix.equals(camera.projectionMatrix);
      if (!shouldPaint) return false;

      paint();
      generation = current;
      hasPainted = true;
      matrixWorld.copy(camera.matrixWorld);
      projectionMatrix.copy(camera.projectionMatrix);
      return true;
    },
  };
};

export type OverlayPaintGate = ReturnType<typeof createOverlayPaintGate>;
